<template>
  <div>
    <section class="content">
      <h2>详情</h2>
      <ul v-if="detail != ''">
        <li v-if="detailsStr.third_name != undefined">
          <label>公司名称：</label>
          <p>{{ detail.third_name }}</p>
        </li>
        <li>
          <label>招聘需求日期：</label>
          <p>{{ detail.demand_day }}</p>
        </li>
        <li>
          <label>状态：</label>
          <p v-if="detail.status == 1">正常</p>
          <p v-else-if="detail.status == 2">停止招聘</p>
          <p v-else>未知</p>
        </li>
        <li>
          <label>项目名称：</label>
          <p>{{ detail.project_name }}</p>
        </li>
        <li>
          <label>备注：</label>
          <p>{{ detail.remark }}</p>
        </li>
        <li>
          <label>提交时间：</label>
          <p>{{ detail.create_time }}</p>
        </li>
        <li>
          <label>修改时间：</label>
          <p>{{ detail.update_time }}</p>
        </li>
        <li>
          <label>提交人员：</label>
          <p>{{ detail.user_name }}</p>
        </li>
        <li v-show="imageUrl != ''">
          <label>附件：</label>
          <viewer :images="imageUrl">
            <img
              class="imgStyle"
              v-for="src in imageUrl"
              :src="src"
              :key="src"
            />
          </viewer>
        </li>
      </ul>
      <h2>缺口需求</h2>
      <div class="tableScroll">
        <table>
          <thead>
            <th>岗位名称</th>
            <th>缺口数量</th>
            <th>性别要求：</th>
            <th>薪资结构</th>
            <th>上班时间</th>
            <th>面试时间</th>
            <th>是否有宿舍</th>
            <th>是否包住</th>
            <th>每月房租</th>
            <th>水电费用</th>
            <th>宿舍距离</th>
            <th>是否包吃/有餐补</th>
            <th>餐费补贴</th>
            <th>是否有食堂</th>
            <th>每餐均价</th>
            <th>工作地址</th>
            <th>发薪时间</th>
            <th>预支</th>
            <th>硬性要求年龄</th>
            <th>硬性要求学历</th>
            <th>硬性要求征信</th>
            <th>是否培训</th>
            <th>培训期工资</th>
            <th>岗位要求</th>
            <th>岗位描述</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in detail.gap_list" :key="index">
              <td>{{ item.position_name }}</td>
              <td>{{ item.persons }}</td>
              <td>
                <p v-show="item.gender == 1">男</p>
                <p v-show="item.gender == 2">女</p>
                <p v-show="item.gender == 3">不限</p>
                <p v-show="item.gender == 0">未知</p>
              </td>
              <td>{{ item.pay_rule }}</td>
              <td>{{ item.work_time }}</td>
              <td>{{ item.recruit_day }}</td>
              <td>
                <p v-show="item.is_dormitory == 1">是</p>
                <p v-show="item.is_dormitory == 2">否</p>
              </td>
              <td>
                <p v-show="item.is_wrap == 1">是</p>
                <p v-show="item.is_wrap == 2">否</p>
              </td>
              <td>{{ item.monthly_rent }}</td>
              <td>{{ item.hydropower_fee }}</td>
              <td>{{ item.hostel_distance }}</td>
              <td>
                <p v-show="item.is_bag_eat == 1">是</p>
                <p v-show="item.is_bag_eat == 2">否</p>
              </td>
              <td>{{ item.meal_supplement }}</td>
              <td>
                <p v-show="item.is_canteen == 1">是</p>
                <p v-show="item.is_canteen == 2">否</p>
              </td>
              <td>{{ item.average_meals }}</td>
              <td>{{ item.work_address }}</td>
              <td>{{ item.pay_time }}</td>
              <td>{{ item.advance }}</td>
              <td>{{ item.age }}</td>
              <td>{{ item.education }}</td>
              <td>{{ item.credit_investigation }}</td>
              <td>
                <p v-show="item.is_train == 1">是</p>
                <p v-show="item.is_train == 2">否</p>
              </td>
              <td>{{ item.train_salary }}</td>
              <td>{{ item.requirement }}</td>
              <td>{{ item.describe }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      imageUrl: []
    };
  },
  props: {
    detailsStr: {}
  },
  mounted() {
    if (this.detailsStr != undefined) {
      this.detail = this.detailsStr;
      if (this.detail.imageUrl != "") {
        this.imageUrl = [this.detail.imageUrl];
      }
    }
  },
  watch: {
    detailsStr() {
      this.detail = this.detailsStr;
      if (this.detail.imageUrl != "") {
        this.imageUrl = [this.detail.imageUrl];
      }
      // console.log(this.detail);
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 4%;
  h2 {
    font-weight: normal;
    line-height: 24px;
    margin-bottom: 20px;
  }
  > ul {
    margin-bottom: 50px;
    > li {
      margin-top: 10px;
      img {
        height: 100px;
        width: 100px;
        object-fit: cover;
      }
      > div {
        display: inline-block;
        vertical-align: top;
      }
      p,
      label {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
  .tableScroll {
    width: 75vw;
    overflow-x: scroll;
    padding-bottom: 30px;
    table {
      border: 1px solid #ccc;
      td,
      th {
        border: 1px solid #ccc;
        padding: 4px 10px;
        line-height: 20px;
        white-space: nowrap;
        background: #fff;
      }
      th {
        background: #ededed;
      }
      td:first-child,
      th:first-child {
        position: sticky;
        left: 0;
        z-index: 99;
      }
    }
  }
}
</style>
